import React from "react";
// react-bootstrap components
import { Auth } from "aws-amplify";
import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import { RiCloseLine } from "react-icons/ri";
import "react-phone-input-2/lib/style.css";
import {
  invokeLambdaWithRetry,
  isEmailChar,
  validateEmail,
} from "services/Helper";
import "../assets/css/style.css";
import logo from "../assets/images/logo.png";
import "../assets/vendors/base/vendor.bundle.base.css";
import "../assets/vendors/ti-icons/css/themify-icons.css";
import CirclesLoader from "../layouts/CirclesLoader";
import MeaBannerIcon from "../../newui/assets/images/login_mea_banner.svg";
import MeaIcon from "../../newui/assets/images/Mea-Logo 1.svg";
import { createUiLogger } from "../../logging/uiLogger";
const console = createUiLogger("meaplatform/classic/views/RegisterUserProfile.js");



function User() {
  const [showModal, setShowModal] = React.useState(false);
  const [showModalMsg, setShowModalMsg] = React.useState("");
  let [password, setPassword] = useState("");
  let [showPassword, setShowPassword] = useState(false);
  let [name, setName] = useState("");
  let [email, setEmail] = useState("");
  let [lastName, setLastName] = useState("");
  let [authenticationCode, setAuthenticationCode] = useState("");
  let [step, setStep] = useState(0);
  const navigate = useNavigate();
  const [captchaResponse, setCaptchaResponse] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const captchaRef = useRef(null);

  const handleCaptchaChange = (response) => {
    setCaptchaResponse(response);
  };

  function convertToUserName(email) {
    return email;
  }

  const allowEmailChars = (e) => {
    if (isEmailChar(e.key) === false) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  const getCognitoUser = async () => {
    setLoading(true);
    try {
      const body = {
        target: "getcognitousers",
        username: email,
      };
      const init = {
        body: body,
      };
      const data = await invokeLambdaWithRetry("instanceHandler", init);
      if (data?.response?.UserStatus === "UNCONFIRMED") {
        setStep(1);
        await resendVerificationCode();
      }
      return { status: data.statusCode === 200, result: data };
    } catch (err) {
      console.error("err: ", err);
      return { status: false, error: err };
    } finally {
      setLoading(false);
    }
  };

  let signUp = async (event) => {
    event.preventDefault();
    setLoading(true);
    await getCognitoUser();
    if (email.trim().length === 0) {
      setShowModalMsg("Email is required");
      setShowModal(true);
      return;
    }
    if (password.trim().length === 0) {
      setShowModalMsg("Enter password");
      setShowModal(true);
      return;
    }
    if (validateEmail(email) !== true) {
      setShowModalMsg("Enter valid email");
      setShowModal(true);
      return;
    }
    try {
      let signupParams = {
        username: email,
        password: password,
        attributes: {
          given_name: name,
          family_name: lastName,
          email: email,
          phone_number: "+919999999999",
          "custom:company": "mea",
          "custom:tandc_accepted": "true",
          "custom:country": "United Kingdom",
        },
        clientMetadata: {
          captcha: JSON.stringify({ captchaResponse }),
        },
      };
      await Auth.signUp(signupParams);
      setStep(1);
      setShowModalMsg(
        "The authentication code sent to your email successfully."
      );
      setShowModal(true);
    } catch (err) {
      setShowModalMsg(err.message);
      setShowModal(true);
      console.error("error signing up :", err);
      if (err.code === "UsernameExistsException") {
        setShowModalMsg(
          <>
            <p>An account with this email already exists.</p>
            <p>
              The authentication code has been successfully resent to your
              email.
            </p>
          </>
        );
      }
      if (err.message.includes("Registration Failed !!")) {
        setShowModalMsg(
          err.message.replace("PreSignUp failed with error", "").trim()
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const resendVerificationCode = async () => {
    try {
        const body = {
        target: "resendotpfordisableduser",
        email: email
      };
      const init = {
        body: body
      };
      const response = await invokeLambdaWithRetry("instanceHandler", init);
      console.info("Resend OTP response:", response);
    } catch (err) {
      console.error("Error resending verification code:", err);
    }
  };

  let confirmSignUp = async (event) => {
    event.preventDefault();
    setLoading(true);
    var username = convertToUserName(email);
    if (username.trim().length === 0) return;
    if (authenticationCode.trim().length === 0) return;
    try {
      try {
        const body = {
          target: "confirmUserSignup",
          authCode: authenticationCode,
          UserId: username,
        };
        const init = {
          body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        if (data.statusCode === 200 && data?.response?.success === true) {
          let path = `/login`;
          navigate(path);
        } else {
          setShowModalMsg(data?.response?.message);
          setShowModal(true);
          return;
        }
      } catch (err) {
        console.error("err: ", err);
        return { status: false, error: err };
      }
    } catch (err) {
      console.error("error confirming signing up :", err);
      setShowModalMsg(err.message);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const redirectToLogin = () => {
    let path = `/login`;
    navigate(path);
  };

  return (
    <>
      <div className="authlayout-container p-3">
        <div className="h-100 authform-container flex">
          <div className="meaicon-banner p-2 flex-center">
            <div className="w-100">
              <img src={MeaBannerIcon} alt="MeaBannerIcon" className="w-100" />
            </div>
          </div>

          <div className="flex authlogo-formcontainer">
            <div className="w-55 flex-colcenter">
              <div>
                <div className="flex-center mb-3">
                  <div className="auth-mealogo-texticon">
                    <img src={logo} alt="MeaIconText" className="w-100" />
                  </div>
                </div>
                <div className="w-100">
                  <div className="flex-center">
                    <h1 className="authform-measlogan-text">make your life</h1>
                  </div>
                  <div className="flex-center">
                    <h1 className="authform-measlogan-text">easier</h1>
                  </div>
                </div>
              </div>
              <p className="authform-limitedyear">
                mea platform limited {new Date().getFullYear()}.
              </p>
            </div>
            <div className="authform-layoutcontainer flex-colcenter">
              <div className="authform-fieldcontainer">
                <div className="mb-2 authform-mealogo-container">
                  <img
                    src={MeaIcon}
                    alt="MEA-ICON"
                    className="authform-mealogoicon"
                  />
                </div>
                <h1 className="formcontainer-title text-center">register</h1>
                <h5 className="text-center authform-subtitle  mt-1 mb-2">
                  Sign up to get started with mea
                </h5>
                {step === 0 && (
                  <form className="pt-3">
                    <div className="form-group mb-0 formcontainer-input-textfield">
                      <label className="login-formlabel text-left">
                        Email address
                      </label>
                      <div className="input-group position-relative">
                        <input
                          type="email"
                          className="formcontainer-inputfield"
                          pattern="[A-Za-z0-9]+"
                          onKeyDown={allowEmailChars}
                          onFocus={() => setShowTooltip(true)} // Show tooltip on focus
                          onChange={(event) => {
                            setEmail(event.target.value);
                            // Extract the part before the @ symbol
                            const namePart = event.target.value.split("@")[0];

                            // Split the name part by the dot
                            const nameParts = namePart.split(".");
                            if (nameParts.length > 1) {
                              // If there is a dot, use the parts before and after the dot
                              setName(nameParts[0]);
                              setLastName(nameParts[1]);
                            } else {
                              // If there is no dot, use the entire part as both first and last names
                              setName(namePart);
                              setLastName(namePart);
                            }
                          }}
                          onBlur={() => {
                            // Hide the tooltip when the input loses focus
                            setShowTooltip(false);
                          }}
                        />
                        {showTooltip && (
                          <div className="email-tooltip">
                            <div className="tooltip-arrow" />
                            Please use your business email address to register
                            with mea platform
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group mb-0 formcontainer-input-textfield position-relative">
                      <label className="login-formlabel text-left mt-2">
                        Password
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="formcontainer-inputfield"
                          id="exampleInputPassword"
                          pattern="[A-Za-z0-9]+"
                          autoComplete="new-password"
                          onChange={(event) => {
                            setPassword(event.target.value);
                          }}
                        />
                        {password && (
                          <span className="show-pwd">
                            <button
                              className="btn p-0 auth-link text-black"
                              onClick={(e) => {
                                e.preventDefault();
                                setShowPassword(!showPassword);
                              }}
                            >
                              {showPassword ? "hide" : "show"}
                            </button>
                          </span>
                        )}
                      </div>
                    </div>

                    {import.meta.env.VITE_ENABLE_CAPTCHA !== "false" && (
                      <div className="form-group mb-0 formcontainer-input-textfield d-flex align-items-center justify-content-center mt-3">
                        <ReCAPTCHA
                          ref={captchaRef}
                          sitekey={import.meta.env.VITE_ENABLE_CAPTCHA}
                          onChange={handleCaptchaChange}
                        />
                        {captchaResponse !== "" && (
                          <i
                            className="fa fa-redo reload-captcha"
                            aria-hidden="true"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Retry"
                            onClick={() => {
                              if (captchaRef.current) {
                                captchaRef.current.reset(); // Reset the ReCAPTCHA
                                setCaptchaResponse("");
                              }
                            }}
                          ></i>
                        )}
                      </div>
                    )}

                    <div className="mt-4 d-flex justify-content-center">
                      <button
                        type="button"
                        className="formfields-button authenticate-btn"
                        disabled={
                          email?.length === 0 ||
                          password?.length === 0 ||
                          captchaResponse?.length === 0
                        }
                        onClick={signUp}
                      >
                        {/* authenticate email address  */}
                        Sign up
                      </button>
                    </div>
                    <div className="row mt-3 ml-3">
                      <div className="col-12">
                        <div className="mb-1 text-black-sm">
                          Note: your password must include the following
                        </div>
                        <div className="mb-1 text-black-sm">
                          8-100 characters
                        </div>
                        <div className="mb-1 text-black-sm">
                          upper & lowercase letters
                        </div>
                        <div className="mb-1 text-black-sm">
                          at least one number or special character
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-1 font-weight-light">
                      <span className="txt-sm mr-1">
                        already have an account?
                      </span>
                      <button
                        type="button"
                        className="btn text-primary p-0"
                        onClick={redirectToLogin}
                      >
                        login
                      </button>
                    </div>
                  </form>
                )}
                {step === 1 && (
                  <form className="pt-3">
                    <h5 className="txt-sm text-center mb-3">
                      Authentication code sent to your email address. Confirm
                      the Authentication code to continue
                    </h5>
                    <div className="form-group mb-0 formcontainer-input-textfield">
                    <label className="login-formlabel text-left">
                            Email address
                          </label>
                      <div className="input-group">
                        <input
                          type="email"
                          className="formcontainer-inputfield"
                          readOnly={true}
                          value={email}
                          onChange={(event) => {
                            setEmail(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group mb-0 formcontainer-input-textfield">
                    <label className="login-formlabel text-left">
                    Authentication Code
                          </label>
                      <div className="input-group">
                        <input
                          type="number"
                          className="formcontainer-inputfield "
                          id="exampleInputPassword"
                          value={authenticationCode}
                          onChange={(event) => {
                            setAuthenticationCode(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="mt-4 d-flex justify-content-center">
                      <button
                        type="button"
                        className="formfields-button mb-3"
                        disabled={authenticationCode.length < 6}
                        onClick={confirmSignUp}
                      >
                        confirm sign up
                      </button>
                    </div>
                    <div className="text-center mt-1 font-weight-light">
                      <span className="txt-sm mr-1">
                        already have an account?
                      </span>
                      <button
                        type="button"
                        className="btn text-primary p-0"
                        onClick={redirectToLogin}
                      >
                        login
                      </button>
                    </div>
                  </form>
                )}
              </div>
              <div className="flex-center">
                <p className="login-footertitle login-div-footer-title">
                  read mea
                  <a
                    className="login-form-footer-text font-Poppins mr-1 ml-1"
                    href="https://www.meaplatform.com/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    privacy policies
                  </a>
                  and
                  <a
                    className="login-form-footer-text font-Poppins mr-1 ml-1"
                    href="https://www.meaplatform.com/terms/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    terms and conditions
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mini Modal */}
      <Modal
        className="modal-mini modal-primary new-modal"
        show={showModal}
        backdrop="static"
        onHide={() => setShowModal(false)}
        animation={false}
        centered={true}
      >
        <Modal.Header className="justify-content-end pt-2">
          <button className="closeicon" onClick={() => setShowModal(false)}>
            <RiCloseLine />
          </button>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="mt-3 mb-2 text-center modal-msg">{showModalMsg}</div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center pb-0">
          <p>
            powered by <span>mea platform</span>
          </p>
        </Modal.Footer>
      </Modal>
      {/* End Modal */}
      {/* Mini Modal */}
      <Modal
        className="modal-centre new-modal"
        backdrop="static"
        keyboard={false}
        show={isLoading}
        animation={false}
        centered={true}
      >
        <Modal.Body className="text-center">
          <CirclesLoader isLoading={isLoading} />
        </Modal.Body>
      </Modal>
      {/* End Modal */}
    </>
  );
}

export default User;
